export default __webpack_public_path__ + "static/media/plain-sticker-N.b37bbd91.png";